module.exports = __webpack_public_path__ + "img/banner-appstore.ff26b620.png";